import { Capacitor } from '@capacitor/core';
import IndexedDBStorage from './IndexedDBStorage';
import FileStorage from './FileStorage';

var isNative = Capacitor.isNativePlatform();
var NativeStorage = FileStorage;


/*
 * open( dir, name ) : retourne un Blob
 * read( dir, name, method = readAsText ) : Lit le Blob ouvert avec FileReader
 * write( dir, name, data, type ) | write( dir, name, Blob ) : écrit les données ou un Blob/File
 * remove( dir, name ) : Supprime
 */
export default {

	open: function( dir, name )
	{
		if( !isNative )
		{
			return IndexedDBStorage.open( dir, name );
		}

		var key = dir + '/' + name;
		var text = localStorage.getItem( key );

		if( !_.isNull( text ) )
		{
			var deferred = $.Deferred();
			return deferred.resolve( new Blob( [ text ], { type: 'plain/text' } ) );
		}

		return NativeStorage.open( dir, name );
	},

	read: function( dir, name, method )
	{
		if( !isNative )
		{
			var deferred = $.Deferred();
			var opener = this.open( dir, name );

			opener.fail( deferred.reject );
			opener.done( function( blob )
			{
				var fr = new FileReader();
				fr[ method || 'readAsText' ]( blob );
				fr.onload = function() { deferred.resolve( this.result ); };
				fr.onerror = deferred.reject;
				fr.onabort = deferred.reject;
			});

			return deferred;
		}

		var deferred = $.Deferred();
		var key = dir + '/' + name;
		var text = localStorage.getItem( key );

		if( !_.isNull( text ) )
		{
			deferred.resolve( text );
		}
		else
		{
			var opener = this.open( dir, name );
			opener.fail( deferred.reject );
			opener.done( function( blob )
			{
				var fr = new FileReader();
				fr[ method || 'readAsText' ]( blob );
				fr.onload = function() { deferred.resolve( this.result ); };
				fr.onerror = deferred.reject;
				fr.onabort = deferred.reject;
			});
		}

		return deferred;
	},

	write: function( dir, name, data, type )
	{
		if( !isNative )
		{
			var blob = data instanceof Blob ? data : new Blob( [ data ], { type: type || 'text/plain' } );
			return IndexedDBStorage.write( dir, name, blob );
		}

		var key = dir + '/' + name;

		try
		{
			if( _.isString( data ) && data.length < 1048576 && [ 'text/plain', 'text/json', 'application/json' ].indexOf( type || 'text/plain' ) >= 0 )
			{
				localStorage.setItem( key, data );

				var deferred = $.Deferred();
				return deferred.resolve( new Blob( [ data ], { type: 'text/plain' } ) );
			}
		}
		catch( e )
		{
			console.error( 'Storage.write', key, 'failed', e );
		}

		localStorage.removeItem( key );

		var blob = data instanceof Blob ? data : new Blob( [ data ], { type: type || 'text/plain' } );
		return NativeStorage.write( dir, name, blob );
	},

	remove: function( dir, name )
	{
		if( !isNative )
		{
			return IndexedDBStorage.remove( dir, name );
		}

		var key = dir + '/' + name;
		localStorage.removeItem( key );
		return NativeStorage.remove( dir, name );
	}
};
